module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-bs-black.591093ab.gif";